import { render, staticRenderFns } from "./DeliveryChangeDateForm.vue?vue&type=template&id=652e7cf1&lang=pug&"
import script from "./DeliveryChangeDateForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryChangeDateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports